import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";


const CreateNotes = (props) => {
    const [NotesTile, setNotesTile] = useState("");
    const [Note, setNote] = useState("");
    const [NoteID, setNoteID] = useState("");
    const [response, fetchData] = UseFetchData();
    const [pageName, setpageName] = useState(props.pageName);
    const [ResponseDelete, fetchDelete] = UseFetchData();
    const [responseGetID, fetchGetIDData] = UseFetchData();

    const validationSchema = Yup.object({
        NotesTile: Yup.string().required("Required!"),
        Note: Yup.string().required("Required!"),
    });

    const onSubmit = values => {
        //console.log(values);
        // debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("NoteID", props.NoteID);
        bodyFormData.append("RefDocumentID", props.RefDocumentID);
        bodyFormData.append("NotesTitle", values.NotesTile);
        bodyFormData.append("Notes", values.Note);
        bodyFormData.append("CreatedByID", sessionStorage.UID);
        fetchData("Activity/SaveNotes", bodyFormData);
    }

    const OnDelete = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("NoteID", props.NoteID);
        fetchDelete("Activity/DeleteNote", bodyFormData);
        props.setNoteOpen(false);
    }

    const GetByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("NoteID", props.NoteID);
        fetchGetIDData("Activity/GetNoteDtls", bodyFormData);
    }

    useEffect(() => {
        // debugger;
        if (response.Response === true) {
            if (pageName === 'Notes') {
                alert("Data Saved Succesfully.");
                props.setNoteOpen(false);
                props.PopulateData();
            }
            else {
                alert("Data Saved Succesfully.");
                props.setNoteOpen(false);
                props.Populate('');
            }
        }
        else if (response.Response === false) {
            alert("Failed.");
        }
    }, [response]);


    useEffect(() => {
        // debugger;
        if (ResponseDelete.Response === true) {
            if (pageName === 'Notes') {
                props.setNoteOpen(false);
                props.PopulateData();

            }
            else {
                props.setNoteOpen(false);
                props.Populate('');
            }
        } else if (ResponseDelete.Response === false) {
            alert("Failed.");
        }
    }, [ResponseDelete]);

    useEffect(() => {
        // debugger;
        if (responseGetID !== undefined && responseGetID.length > 0) {
            setNoteID(responseGetID[0].NoteID);
            setNote(responseGetID[0].Notes);
            setNotesTile(responseGetID[0].NotesTitle);
        }
    }, [responseGetID])

    useEffect(() => {
        if (props.NoteID !== "") {
            GetByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{ NotesTile: NotesTile, Note: Note, NoteID: NoteID }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={1} container>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Note Tile'
                                    name='NotesTile'
                                    onChange={(e) => { setNotesTile(e.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <BiztranControlsFormik
                                    control='textarea'
                                    type='text'
                                    label='Note'
                                    name='Note'
                                    onChange={(e) => { setNote(e.target.value) }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setNoteOpen(false); }}
                                        />
                                        <BiztranControls.Button
                                            text="Delete"
                                            startIcon={<CloseIcon />}
                                            onClick={OnDelete}
                                        // disabled={DisableDelete}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateNotes;
